import React, {useState} from 'react';
import {candidateHooks} from "../../../api/candidate.api";
import moment from "moment";

const MAX_LENGTH = 150;

const ResumeComments = ({vacancyId, resumeId}: { vacancyId?: number; resumeId?: number }) => {
  const {data, isLoading, error} = candidateHooks.useResumeComments(vacancyId, resumeId);
  const [expandedComments, setExpandedComments] = useState<{ [key: number]: boolean }>({});

  const toggleExpand = (commentId: number) => {
    setExpandedComments((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };

  if (!vacancyId || !resumeId) {
    return <p>Выберите вакансию и резюме для просмотра комментариев.</p>;
  }

  if (isLoading) return <p>Загрузка комментариев...</p>;
  if (error) return <p>Ошибка: {error.message}</p>;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-2">Комментарии:</h3>
      {data && data.length > 0 ? (
        <div className="flex flex-col gap-2">
          {data.map((comment) => (
            <div key={comment.id} className="text-sm flex gap-4 text-gray-500">
              {/* Автор комментария */}
              <div className="font-medium w-1/3">
                <p>
                  {comment.author?.fullName}
                </p>
                <p className={'mt-1'}>
                  {comment.author?.email}
                </p>
              </div>


              {/* Комментарий */}
              <span
                onClick={() => toggleExpand(comment.id)}
                className={`w-1/2 font-semibold text-gray-400 ${comment.comment.length > MAX_LENGTH ? 'cursor-pointer' : ''}`}
              >
                  {comment.comment.length > MAX_LENGTH && !expandedComments[comment.id]
                    ? (
                      <>
                        {comment.comment.slice(0, MAX_LENGTH)}
                        <span className="text-blue-400 font-semibold"> Далее...</span>
                      </>
                    )
                    : comment.comment}
              </span>

              {/* Дата комментария */}
              <span className="font-medium w-1/4 text-right">
                {comment.date && moment(comment.date).format('HH:mm DD.MM.YYYY')}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">Комментариев нет</p>
      )}
    </div>
  );
};

export default ResumeComments;
